/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AttributeService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AttributeService\' loaded');
    }
}

export { AttributeService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AttributeService.js